import { inject, Injectable } from '@angular/core'
import type { Observable } from 'rxjs'

import { HttpService } from '@app/modules/http/services/http.service'
import { PwaService } from '@app/modules/pwa/services/pwa.service'

interface NotificationsSync {
  badge_count: number
}

@Injectable({
  providedIn: 'root',
})
export class BadgesService {
  private readonly pwaService = inject(PwaService)
  private readonly httpService = inject(HttpService)

  isEnabled(): boolean {
    return this.pwaService.isAppInstalled() && Boolean(window.navigator.setAppBadge)
  }

  sync(): Observable<NotificationsSync> {
    return this.httpService.get<NotificationsSync>('/notifications/sync')
  }

  async setAppBadge(badgeCount: number): Promise<void> {
    await window.navigator.setAppBadge?.(badgeCount)
  }

  async cleanBadges(): Promise<void> {
    await this.setAppBadge(0)
  }
}
